import { Funcoes } from './utils';

// valida chave de acesso de NF-e / NFC-e (44 dígitos)
// opções:
//   modelosPermitidos: [55, 65] por padrão
//   validarUF: false por padrão (se true, checa cUF válido)
//   validarMes: true por padrão (MM entre 01..12)
function validarChaveAcesso(chave, opts = {}) {
    if (!chave) throw new Error('Chave não informada');

    const {
        modelosPermitidos = [55, 65],
        validarUF = false,
        validarMes = true,
    } = opts;

    const cleaned = String(chave).replace(/\D/g, '');
    if (cleaned.length !== 44) throw new Error('Chave deve conter 44 dígitos');
    if (/^(\d)\1{43}$/.test(cleaned)) throw new Error('Chave inválida (sequência repetida)');

    // campos (conforme layout da SEFAZ)
    const cUF     = cleaned.slice(0, 2);      // código da UF (IBGE)
    const AAMM    = cleaned.slice(2, 6);      // ano/mes (AAMM)
    const modelo  = Number(cleaned.slice(20, 22)); // 55 (NF-e) ou 65 (NFC-e)
    // const serie   = cleaned.slice(22, 25);
    // const nNF     = cleaned.slice(25, 34);
    // const tpEmis  = cleaned.slice(34, 35);
    // const cNF     = cleaned.slice(35, 43);
    const dvInf   = Number(cleaned.slice(43));     // dígito verificador informado

    if (modelosPermitidos?.length && !modelosPermitidos.includes(modelo)) {
        throw new Error('Modelo inválido (esperado 55 ou 65)');
    }

    if (validarUF) {
        const UFs = new Set([
        '11','12','13','14','15','16','17', // Norte
        '21','22','23','24','25','26','27','28','29', // Nordeste
        '31','32','33','35', // Sudeste
        '41','42','43',      // Sul
        '50','51','52','53'  // Centro-Oeste
        ]);
        if (!UFs.has(cUF)) throw new Error('UF inválida na chave');
    }

    if (validarMes) {
        const mm = Number(AAMM.slice(2, 4));
        if (mm < 1 || mm > 12) throw new Error('Mês inválido na chave');
    }

    // cálculo do DV (módulo 11) nos 43 primeiros dígitos
    const numeros = cleaned.slice(0, 43).split('').map(Number);
    let peso = 2, soma = 0;
    for (let i = numeros.length - 1; i >= 0; i--) {
        soma += numeros[i] * peso;
        peso = (peso === 9) ? 2 : (peso + 1); // pesos 2..9 cíclicos da direita pra esquerda
    }
    const resto = soma % 11;
    const dvCalc = (resto === 0 || resto === 1) ? 0 : (11 - resto);

    if (dvCalc !== dvInf) throw new Error('Chave inválida (dígito verificador incorreto)');
}


function validarCNPJ(cnpj) {
    if (!cnpj) throw new Error('CNPJ não informado');

    const cleaned = cnpj.replace(/\D/g, '');
    if (cleaned.length !== 14) throw new Error('CNPJ deve conter 14 dígitos');
    if (/^(\d)\1{13}$/.test(cleaned)) throw new Error('CNPJ inválido');

    const pesos1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesos2 = [6, ...pesos1];

    const calcularDigito = (base, pesos) => {
        const soma = base.reduce((acc, num, i) => acc + num * pesos[i], 0);
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    const numeros = cleaned.split('').map(Number);
    const base = numeros.slice(0, 12);
    const digito1 = calcularDigito(base, pesos1);
    const digito2 = calcularDigito([...base, digito1], pesos2);

    if (digito1 !== numeros[12] || digito2 !== numeros[13]) {
        throw new Error('CNPJ inválido');
    }
}

function validarCPF(cpf) {
    if (!cpf) throw new Error('CPF não informado');

    const cleaned = cpf.replace(/\D/g, '');
    if (cleaned.length !== 11) throw new Error('CPF deve conter 11 dígitos');
    if (/^(\d)\1{10}$/.test(cleaned)) throw new Error('CPF inválido');

    let soma = 0;
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cleaned.charAt(i)) * (10 - i);
    }

    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cleaned.charAt(9))) throw new Error('CPF inválido');

    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cleaned.charAt(i)) * (11 - i);
    }

    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cleaned.charAt(10))) throw new Error('CPF inválido');
}

function validarCNPJouCPF(dados) {
    if (!dados) throw new Error('CPF/CNPJ não informado');
    const cleaned = dados.replace(/\D/g, '');
    (cleaned.length > 11) ? validarCNPJ(dados) : validarCPF(dados);
}

function validarData(dataStr, diasMinimos = 0) {
    if (!dataStr) throw new Error('Data não informada');

    const dataInformada = Funcoes.parseDataLocal(dataStr);
    dataInformada.setHours(0, 0, 0, 0);

    const dataLimite = new Date();
    dataLimite.setHours(0, 0, 0, 0);
    dataLimite.setDate(dataLimite.getDate() + diasMinimos);

    if (dataInformada < dataLimite) {
        throw new Error(`A data deve ser igual ou superior a ${Funcoes.formatDate(dataLimite)}`);
    }
}

function validarHora(hora) {
    if (!hora) throw new Error('Hora não informada');
    const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
    if (!regex.test(hora)) throw new Error('Informe corretamente a hora');
}


function validarId(obj, msg = 'Necessário selecionar um registro') {
    if (Funcoes.getId(obj)<1) {
        throw new Error(msg);
    }
}


function validarIntervaloDatas(startDate, endDate, obrigatorio = true) {
    if (!startDate || !endDate) {
        if (obrigatorio) throw new Error('Necessário informar ambas as datas.');
        else return;
    }

    const dataInicio = new Date(startDate);
    const dataFim = new Date(endDate);

    if (isNaN(dataInicio.getTime()) || isNaN(dataFim.getTime())) {
        throw new Error('Datas inválidas. Verifique o formato das datas.');
    }

    if (dataFim < dataInicio) {
        throw new Error('A data final deve ser maior ou igual à data inicial.');
    }
}

function validarDataNoMes(dataStr, anomes) {
    if (!dataStr) throw new Error('Data não informada');

    // const data = new Date(dataStr);
    const data = Funcoes.parseDataLocal(dataStr);
    const ano = data.getFullYear();
    const mes = data.getMonth() + 1;
    const anomesData = ano * 100 + mes;

    if (anomesData !== anomes) {
        throw new Error('Data não corresponde ao período informado.');
    }
}

function validarTexto(valor, mensagem = 'Texto não informado') {
    if (!valor || valor.trim() === '') {
        throw new Error(mensagem);
    }
}

export const Validacoes = {
    validarChaveAcesso,
    validarCNPJ,
    validarCPF,
    validarCNPJouCPF,
    validarData,
    validarHora,
    validarId,
    validarIntervaloDatas,
    validarDataNoMes,
    validarTexto,
};
